import React from "react";
import { Link } from "react-router-dom";

const Step = ({ n, title, desc }) => (
  <div className="cm-card">
    <div className="w-10 h-10 rounded-full bg-[#1a2b4a] text-white text-sm font-bold flex items-center justify-center mb-4">{n}</div>
    <h3 className="text-lg font-semibold text-[#1a2b4a] mb-1">{title}</h3>
    <p className="text-sm text-[#475569] leading-relaxed">{desc}</p>
  </div>
);

export default function HowItWorks() {
  return (
    <div className="cm-container py-14">
      <div className="max-w-3xl">
        <div className="cm-eyebrow mb-2">How it works</div>
        <h1 className="cm-h2">Five steps between you and the right care.</h1>
        <p className="cm-body mt-3">Every step is designed to reduce friction and build trust. No forms, no jargon, no guesswork.</p>
      </div>
      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Step n="1" title="Share what's happening" desc="Answer a few gentle questions in plain English. Our AI health navigator asks one at a time and knows when to stop."/>
        <Step n="2" title="Get a routing suggestion" desc="You'll see whether a GP or specialist looks right &mdash; not a diagnosis, a starting point."/>
        <Step n="3" title="Choose your doctor" desc="Filter by specialty, language, price and availability. Every doctor is verified and insured."/>
        <Step n="4" title="Book and pay securely" desc="Pick a time and pay with Stripe. Prices are shown before you book &mdash; £50 general or £70 specialist."/>
        <Step n="5" title="Meet on secure video" desc="A quick pre-check ensures your camera and mic work. The doctor already has your AI-assisted brief."/>
        <Step n="6" title="Care Passport keeps everything" desc="Notes, prescriptions, referrals, follow-ups &mdash; all in one place. Owned by you."/>
      </div>
      <div className="mt-14">
        <Link to="/patient/intake" className="cm-btn-primary" data-testid="hiw-start-cta">Start with AI health navigator</Link>
      </div>
    </div>
  );
}
